<template>
  <div ref="control" class="pa-2">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    google: Object,
    map: Object
  },
  mounted () {
    this.drawControl()
  },
  methods: {
    drawControl () {
      const control = this.$refs.control
      this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(control)
    }
  }
}
</script>
